export enum RouteData {
  RequiredCompleteness = 'requiredCompleteness',
  AllowedRoles = 'allowedRoles',
  HideNavItems = 'hideNavItems',
}
